"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _Raven = _interopRequireDefault(require("Raven"));

function _default() {
  return function (next) {
    return function (action) {
      var type = action.type;

      if (type.indexOf('_FAILED') > -1) {
        _Raven.default.captureMessage(type, {
          extra: {
            action: action
          }
        });
      }

      return next(action);
    };
  };
}

module.exports = exports.default;